import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { FormService } from '@complete-order/services/form-service.service';
import { Address, Contact, ItemOffer } from '@dgx-pr-spa/shared/util';
import { ProductDetailsService } from '@product-details/services/product-details.service';
import { UrlService } from '@shared/services/url.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';

@Component({
  selector: 'app-complete-order-container',
  templateUrl: './complete-order-container.component.html',
  styleUrls: ['./complete-order-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompleteOrderContainerComponent implements OnChanges {
  constructor(
    public viewOffersService: ViewOffersService,
    public productDetailsService: ProductDetailsService,
    public additionalServicesService: AdditionalServicesService,
    public completeOrderService: CompleteOrderService,
    public formService: FormService,
    public router: Router,
    public urlService: UrlService
  ) {
    this.form = this.formService.createForm();
  }

  @Input() offerReference: string;
  @Input() deliveryAddress: Address;
  @Input() contact: Contact;
  @Input() itemOffer: ItemOffer;
  @Input() offerStatus: string;

  form: UntypedFormGroup;
  activeStep$ = this.completeOrderService.activeFormStep$;
  currentPlan$ = this.viewOffersService.currentPlan$;
  itemOfferError$ = this.additionalServicesService.itemOfferError$;
  previousUrl$ = this.urlService.previousUrl$;

  /**
   * Update default form data on changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.deliveryAddress) {
      this.setDeliveryFormData();
    }
    if (changes.itemOffer) {
      this.setDirectDebitFormData();
      this.completeOrderService.loadUpfrontPayment();
    }
  }

  /**
   * Update delivery address form data
   */
  setDeliveryFormData() {
    this.form.patchValue({
      delivery: this.formService.defaultDeliveryData(
        this.deliveryAddress,
        this.contact
      ),
    });
  }

  /**
   * Update direct debit form data
   */
  setDirectDebitFormData() {
    this.form.patchValue({
      directDebit: this.formService.defaultDirectDebitData(this.itemOffer),
    });
  }
}
